// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLetterAvatar from 'vue-letter-avatar'
import Fullscreen from 'vue-fullscreen'
import Vuetify from 'vuetify'
import store from './store'
import Notifications from 'vue-notification'
import '@mdi/font/css/materialdesignicons.css'
import env_variables from '../env_variables'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'cropperjs/dist/cropper.css'
import 'bpmn-js-properties-panel/dist/assets/bpmn-js-properties-panel.css'
import 'dmn-js-properties-panel/dist/assets/dmn-js-properties-panel.css'
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css'
import 'bpmn-js/dist/assets/diagram-js.css'
import 'dmn-js/dist/assets/dmn-font/css/dmn-embedded.css'
import 'dmn-js/dist/assets/diagram-js.css'
import 'dmn-js/dist/assets/dmn-js-decision-table.css'
import 'dmn-js/dist/assets/dmn-js-decision-table-controls.css'
import 'dmn-js/dist/assets/dmn-js-drd.css'
import 'dmn-js/dist/assets/dmn-js-literal-expression.css'
import 'dmn-js/dist/assets/dmn-js-shared.css'
import 'diagram-js-minimap/assets/diagram-js-minimap.css'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import TreeView from 'vue-json-tree-view'
import '@babel/polyfill'
import velocity from 'velocity-animate'
import 'cronstrue'
import 'vis-network'
import 'vue-color'
import VJsoneditor from 'v-jsoneditor/src/index'
import 'marked'
import 'fuse.js'
import 'vuetify/dist/vuetify.min.css'
import axios from 'axios'
import VuetifyConfirm from 'vuetify-confirm'
import MSALInstance from './auth/auth'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { ApmVuePlugin } from '@elastic/apm-rum-vue'

axios.interceptors.request.use(async config => {
  const { userId, msalConfig, loginRequest } = MSALInstance
  if (userId) {
    try {
      loginRequest.account = msalConfig.getAccountByHomeId(userId)
      const response = await msalConfig.acquireTokenSilent(loginRequest)
      config.headers.Authorization = `Bearer ${response.accessToken}`
    } catch (e) {
      if (e instanceof InteractionRequiredAuthError) {
        loginRequest.account = msalConfig.getAccountByHomeId(userId)
        const response = await msalConfig.acquireTokenRedirect(loginRequest)
        config.headers.Authorization = `Bearer ${response.accessToken}`
      } else {
        router.push('no-session')
      }
    }
  } else {
    const token = localStorage.getItem('BasicPasstoken')
    config.headers.Authorization = 'Basic ' + token
  }
  return config
})

axios.interceptors.response.use(
  function(response) {
    return response
  },
  function(error) {
    console.log(error.response.data)
    if (error.response.status === 401) {
      router.push('no-session')
    }
    return Promise.reject(error)
  }
)

Vue.use(VuetifyConfirm)
Vue.use(TreeView)
Vue.use(VueLetterAvatar) // This library has exported a plugin by default, le sigh
Vue.use(Fullscreen) // This library also exports a plugin by default although the component can be accessed from src
Vue.use(Vuetify, {
  iconfont: 'md',
  customProperties: true
})
Vue.use(VJsoneditor)
Vue.use(Notifications, { velocity })
Vue.use(ApmVuePlugin, {
  router,
  config: {
    serviceName: 'tulip-honey-service',
    serverUrl: '/',
    serviceVersion: env_variables.serviceVersion,
    environment: env_variables.environment
  }
})

Vue.config.productionTip = false
Vue.config.silent = true

/* eslint-disable no-new */
var app = new Vue({
  el: '#app',
  store,
  router,
  components: {
    App
  },
  template: '<App/>'
})

window.app = app
